<template>
  <div class="markBox">
    <div class="mark">
      <div class="markItem">差</div>
      <div class="markItem">中</div>
      <div class="markItem">良</div>
      <div class="markItem">优</div>
      <div class="markStar">0</div>
      <div class="markEnd">100</div>
      <div
        :class="
          item.status == '差'
            ? 'markIcon'
            : item.status == '中'
            ? 'markIcon markIconZ'
            : item.status == '良'
            ? 'markIcon markIconL'
            : 'markIcon markIconY'
        "
      >
        <span>{{ item.value }}</span>
        <img :src="colorsImg[item.level - 1]" />
      </div>
    </div>
    <div class="markText">
      <div class="markTextItem" v-for="(item, index) in textList" :key="index">
        <span
          class="span1"
          :style="{
            background:
              item.status == '差'
                ? '#D45353'
                : item.status == '中'
                ? '#F1BE33'
                : item.status == '良'
                ? '#9EF133'
                : '#28D200',
          }"
          >{{ item.status }}</span
        >
        <span class="span2">{{ item.pppp }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['item'],
  data () {
    return {
      lev: 0,
      colorsImg: [
        require('../../../assets/image/anxin/jiantou1.png'),
        require('../../../assets/image/anxin/jiantou2.png'),
        require('../../../assets/image/anxin/jiantou3.png'),
        require('../../../assets/image/anxin/jiantou4.png'),
      ],
      textList: [
        {
          status: '差',
          pppp: '≤60分，差，请进一步检查并遵医嘱。'
        },
        {
          status: '中',
          pppp: ' 61~74分，中，存在代谢紊乱，需引起重视。'
        },
        {
          status: '良',
          pppp: ' 75~84分，良， 注意监测。 '
        },
        {
          status: '优',
          pppp: '85~100分，优，注意保持。'
        }
      ]
    }
  },
  watch: {
    item (newVal) {
      console.log(newVal)
    }
  },
  created () {

  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.markBox {
  padding: 0 30px;
}
.mark {
  width: 100%;
  margin: 80px auto 0px auto;
  position: relative;
  height: 80px;
  .markStar {
    position: absolute;
    left: 0;
    bottom: 66px;
    font-size: 24px;
  }
  .markEnd {
    position: absolute;
    right: 0;
    bottom: 66px;
    font-size: 24px;
  }
  .markIcon {
    position: absolute;
    width: 25%;
    text-align: center;
    color: #d45353;
    bottom: 85px;
    img {
      width: 19px;
      height: 29px;
    }
    span {
      display: inline-block;
      width: 100%;
      font-size: 28px;
    }
  }

  .markIconZ {
    color: #f1be33;
    left: 25%;
  }
  .markIconL {
    color: #9ef133;
    left: 50%;
  }
  .markIconY {
    color: #28d200;
    left: 75%;
  }
  .markItem {
    width: 25%;
    display: inline-block;
    position: relative;
    float: left;
    text-align: center;
    font-size: 24px;
  }
  .markItem::before {
    content: "";
    width: 100%;
    height: 15px;
    background: #000;
    position: absolute;
    left: 0;
    top: -40px;
  }
  .markItem:nth-child(1) {
    color: #d45353;
  }
  .markItem:nth-child(2) {
    color: #f1be33;
  }
  .markItem:nth-child(3) {
    color: #9ef133;
  }
  .markItem:nth-child(4) {
    color: #28d200;
  }
  .markItem:nth-child(1):before {
    background: #d45353;
    color: #d45353;
  }
  .markItem:nth-child(2):before {
    background: #f1be33;
    color: #f1be33;
  }
  .markItem:nth-child(3):before {
    background: #9ef133;
    color: #9ef133;
  }
  .markItem:nth-child(4):before {
    background: #28d200;
    color: #28d200;
  }
}
.markText {
  margin-top: -30px;
  margin-bottom: 30px;
  .markTextItem {
    margin-bottom: 10px;
  }
  .markTextItem .span1 {
    width: 50px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    display: inline-block;
    font-size: 15px;
    color: #fff;
    vertical-align: middle;

    border-radius: 5px;
  }
  .markTextItem .span2 {
    margin-left: 15px;
    font-size: 24px;
    vertical-align: middle;
  }
}
</style>